import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontSize: '1.2rem', fontWeight: '600', color: '#00F2FE',
      marginBottom: '1rem', paddingBottom: '0.5rem',
      borderBottom: '1px solid rgba(0, 242, 254, 0.15)',
    }}>
      {title}
    </h2>
    <div style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.8', fontSize: '0.95rem' }}>
      {children}
    </div>
  </section>
);

const InfoBox = ({ children }) => (
  <div style={{
    background: 'rgba(0,242,254,0.04)', borderRadius: '10px',
    padding: '1rem 1.2rem', border: '1px solid rgba(0,242,254,0.08)',
    marginTop: '0.8rem', display: 'flex', flexDirection: 'column', gap: '0.35rem',
  }}>
    {children}
  </div>
);

const CGUPage = () => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #050B1A 0%, #0A1628 50%, #0F1B3C 100%)',
    padding: '2rem 1rem 4rem',
  }}>
    <div style={{ maxWidth: '760px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '3rem' }}>
        <Link to="/" style={{
          color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem',
          display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
          marginBottom: '2rem', transition: 'color 0.2s',
        }}
          onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
        >
          ← Retour à l'accueil
        </Link>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: '700',
          color: 'white', marginBottom: '0.5rem', letterSpacing: '-0.02em',
        }}>
          Conditions Générales d'Utilisation
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>
          SafeHeir — Dernière mise à jour : Mai 2026
        </p>
      </div>

      <div style={{
        background: 'rgba(10, 22, 40, 0.6)', backdropFilter: 'blur(20px)',
        borderRadius: '20px', padding: '2.5rem',
        border: '1px solid rgba(0, 242, 254, 0.1)',
      }}>

        <Section title="1. Identification de l'éditeur">
          <p>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation
            du service SafeHeir, édité par :</p>
          <InfoBox>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Éditeur :</strong> Azzedi Salemkour</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Statut juridique :</strong> Projet en cours de structuration juridique</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>SIREN :</strong> En cours d'immatriculation</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Adresse :</strong> Gennevilliers, 92230, France</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Contact :</strong>{' '}
              <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
                contact@safeheir.fr
              </a>
            </p>
          </InfoBox>
        </Section>

        <Section title="2. Objet du service">
          <p>SafeHeir est un service de transmission sécurisée d'accès numériques. Il permet à
            l'utilisateur de centraliser ses identifiants et mots de passe, de désigner des bénéficiaires,
            et de configurer une transmission automatique en cas d'absence prolongée ou de décès.</p>
          <br />
          <p>SafeHeir n'est <strong style={{ color: 'rgba(255,255,255,0.9)' }}>pas</strong> un service
            juridique, notarial ou d'archivage légalement opposable. Il s'agit d'un outil pratique
            destiné à faciliter la transmission d'informations numériques à des personnes de confiance
            désignées par l'utilisateur.</p>
        </Section>

        <Section title="3. Accès au service">
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li>— L'accès au service requiert la création d'un compte avec une adresse email et un mot de passe.</li>
            <li>— SafeHeir est actuellement en version bêta. Des modifications et interruptions peuvent survenir sans préavis.</li>
            <li>— L'accès est gratuit pendant la phase bêta. Des fonctionnalités payantes pourront être proposées ultérieurement.</li>
          </ul>
        </Section>

        <Section title="4. Responsabilités de l'utilisateur">
          <p>L'utilisateur est seul responsable :</p>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0.8rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <li>— de l'exactitude des informations saisies ;</li>
            <li>— de la sécurité de son mot de passe ;</li>
            <li>— du choix et de la fiabilité de ses bénéficiaires ;</li>
            <li>— des conséquences de la transmission d'accès à des tiers.</li>
          </ul>
          <br />
          <p>L'utilisateur s'engage à ne pas utiliser SafeHeir à des fins illicites ou pour stocker des
            données appartenant à des tiers sans leur consentement.</p>
        </Section>

        <Section title="5. Limites du service et avertissement de perte de données">
          <p style={{ color: 'rgba(255,200,100,0.9)', marginBottom: '0.8rem' }}>
            SafeHeir est un service en cours de développement. À ce stade :
          </p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li>— Vos données sont chiffrées côté client et hébergées sur des serveurs européens (Supabase, Stockholm).</li>
            <li>— La perte du mot de passe entraîne la perte définitive de l'accès au coffre-fort.
              Aucune récupération n'est possible.</li>
            <li>— Aucune garantie de disponibilité continue du service n'est assurée.</li>
            <li>— La transmission aux bénéficiaires repose sur un système de notifications email dont
              le bon fonctionnement dépend de services tiers.</li>
            <li>— SafeHeir n'intervient pas dans la relation entre l'utilisateur et ses bénéficiaires.</li>
          </ul>
        </Section>

        <Section title="6. Utilisations interdites">
          <p>Il est interdit d'utiliser SafeHeir pour :</p>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0.8rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <li>— stocker des données appartenant à des tiers sans leur consentement ;</li>
            <li>— contourner des dispositifs de sécurité informatique ;</li>
            <li>— toute activité contraire à la réglementation française ou européenne en vigueur.</li>
          </ul>
        </Section>

        <Section title="7. Propriété intellectuelle">
          <p>L'ensemble des éléments constitutifs du service SafeHeir — incluant, sans s'y limiter, la
            marque SafeHeir, le code source, les interfaces graphiques, les textes, les logotypes et tout
            autre contenu — est protégé par les dispositions du Code de la propriété intellectuelle.</p>
          <br />
          <p>Toute reproduction, représentation, modification, publication, adaptation ou exploitation,
            totale ou partielle, de ces éléments, par quelque procédé que ce soit, sans l'autorisation
            écrite préalable de l'éditeur, est strictement interdite et constitue une contrefaçon
            sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.</p>
          <br />
          <p>L'utilisation du service ne confère à l'utilisateur aucun droit de propriété intellectuelle
            sur les éléments du site ou du service SafeHeir.</p>
        </Section>

        <Section title="8. Suppression de compte">
          <p>Vous pouvez supprimer l'ensemble de vos données SafeHeir à tout moment depuis la page{' '}
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Paramètres → Supprimer mon compte</strong>.
            Cette opération efface immédiatement et définitivement votre compte, votre coffre-fort, vos
            bénéficiaires et votre historique de check-in du localStorage de votre navigateur. Cette
            action est irréversible.</p>
          <br />
          <p>SafeHeir se réserve le droit de suspendre l'accès à un compte en cas d'utilisation abusive
            ou contraire aux présentes CGU.</p>
        </Section>

        <Section title="9. Modifications des CGU">
          <p>SafeHeir peut modifier ces CGU à tout moment. La poursuite de l'utilisation du service
            vaut acceptation des nouvelles conditions. Les modifications significatives seront signalées
            aux utilisateurs connectés.</p>
        </Section>

        <Section title="10. Droit applicable et juridiction compétente">
          <p>Les présentes CGU sont régies exclusivement par le droit français.</p>
          <br />
          <p>En cas de litige relatif à l'interprétation, à l'exécution ou à la résiliation des
            présentes, et à défaut de résolution amiable dans un délai de trente (30) jours à compter
            de la notification du différend par l'une ou l'autre des parties, le litige sera soumis à
            la compétence exclusive du{' '}
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Tribunal judiciaire de Paris</strong>,
            nonobstant pluralité de défendeurs ou appel en garantie.</p>
        </Section>

        <Section title="11. Contact">
          <p>Pour toute question relative aux présentes CGU :{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              contact@safeheir.fr
            </a>
          </p>
        </Section>

      </div>

      {/* Footer navigation */}
      <div style={{ marginTop: '2rem', textAlign: 'center', display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        {[
          { to: '/legal/confidentialite', label: 'Politique de confidentialité' },
          { to: '/legal/mentions-legales', label: 'Mentions légales' },
          { to: '/faq', label: 'FAQ' },
          { to: '/', label: 'Accueil' },
        ].map(({ to, label }) => (
          <Link key={to} to={to} style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
            onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
          >
            {label}
          </Link>
        ))}
      </div>

    </div>
  </div>
);

export default CGUPage;
